import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {COLORS, scale, SCALE_COLORS} from '../constants';

const RiskScaleBadges: React.FC = () => {
  return (
    <View style={styles.riskScaleRow}>
      {scale.map(code => (
        <Text
          key={code}
          style={[
            styles.riskScaleBadge,
            {backgroundColor: SCALE_COLORS[code] ?? COLORS.textMuted},
          ]}
        >
          {code}
        </Text>
      ))}
    </View>
  );
};

export default RiskScaleBadges;
